import { render, staticRenderFns } from "./relatorios-icon.vue?vue&type=template&id=14ec4bbe&"
import script from "./relatorios-icon.vue?vue&type=script&lang=js&"
export * from "./relatorios-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports